import React, { useState } from 'react';
import { useNavigate, useSearchParams, Link } from 'react-router-dom';
import { motion } from 'framer-motion';
import { FaFutbol, FaLock, FaEye, FaEyeSlash } from 'react-icons/fa';
import toast from 'react-hot-toast';
import Button from '../components/UI/Button';
import api from '../api/axios';

function ResetPassword() {
  const navigate = useNavigate();
  const [searchParams]  = useSearchParams();
  const token           = searchParams.get('token');

  const [password, setPassword]           = useState('');
  const [confirm, setConfirm]             = useState('');
  const [showPassword, setShowPassword]   = useState(false);
  const [loading, setLoading]             = useState(false);

  const isValid = password.length >= 6 && password === confirm;

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!isValid) {
      toast.error('Vérifie les mots de passe (6 min., doivent correspondre)');
      return;
    }

    setLoading(true);
    try {
      await api.post('/auth/reset-password', { token, password });
      toast.success('Mot de passe mis à jour ! Tu peux te connecter.');
      navigate('/login');
    } catch (err) {
      const msg = err?.response?.data?.message || 'Lien invalide ou expiré';
      toast.error(msg);
    } finally {
      setLoading(false);
    }
  };

  if (!token) {
    return (
      <div className="app-container flex flex-col min-h-screen items-center justify-center px-6"
           style={{ background: 'radial-gradient(ellipse at top, #003DA5 0%, #001a4d 70%)' }}>
        <div className="text-5xl mb-4">❌</div>
        <p className="text-white/60 text-center mb-4">Lien invalide ou manquant.</p>
        <Link to="/forgot-password" className="text-qfl-gold font-bold hover:text-yellow-400">
          Faire une nouvelle demande
        </Link>
      </div>
    );
  }

  return (
    <div
      className="app-container flex flex-col min-h-screen"
      style={{ background: 'radial-gradient(ellipse at top, #003DA5 0%, #001a4d 70%)' }}
    >
      <div
        className="flex-shrink-0 h-40 flex flex-col items-center justify-end pb-5"
        style={{ background: 'radial-gradient(ellipse at 50% 0%, rgba(255,184,28,0.15) 0%, transparent 70%)' }}
      >
        <motion.div
          initial={{ scale: 0 }}
          animate={{ scale: 1 }}
          transition={{ type: 'spring', stiffness: 200 }}
          className="w-16 h-16 rounded-full bg-qfl-card border-2 border-qfl-gold flex items-center justify-center mb-2"
          style={{ boxShadow: '0 0 20px rgba(255,184,28,0.3)' }}
        >
          <FaFutbol size={28} className="text-qfl-gold" />
        </motion.div>
        <h1
          className="text-2xl font-black uppercase tracking-widest"
          style={{ fontFamily: "'Rajdhani', sans-serif", color: '#FFB81C' }}
        >
          OM QUIZ
        </h1>
      </div>

      <motion.div
        className="flex-1 flex flex-col justify-center px-6 py-8"
        initial={{ opacity: 0, y: 30 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ delay: 0.2 }}
      >
        <h2
          className="text-xl font-bold text-white mb-2 text-center"
          style={{ fontFamily: "'Rajdhani', sans-serif" }}
        >
          NOUVEAU MOT DE PASSE
        </h2>
        <p className="text-white/50 text-sm text-center mb-6">Choisis un nouveau mot de passe sécurisé (6 min.).</p>

        <form onSubmit={handleSubmit} className="flex flex-col gap-4">
          <div className="relative">
            <FaLock size={14} className="absolute left-4 top-1/2 -translate-y-1/2 text-white/40" />
            <input
              type={showPassword ? 'text' : 'password'}
              placeholder="Nouveau mot de passe"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              className={`form-input pl-11 pr-11 ${password.length > 0 && password.length < 6 ? 'border-qfl-red/60' : ''}`}
            />
            <button
              type="button"
              onClick={() => setShowPassword(!showPassword)}
              className="absolute right-4 top-1/2 -translate-y-1/2 text-white/40 hover:text-white/70"
            >
              {showPassword ? <FaEyeSlash size={14} /> : <FaEye size={14} />}
            </button>
          </div>

          <div className="relative">
            <FaLock size={14} className="absolute left-4 top-1/2 -translate-y-1/2 text-white/40" />
            <input
              type={showPassword ? 'text' : 'password'}
              placeholder="Confirmer le mot de passe"
              value={confirm}
              onChange={(e) => setConfirm(e.target.value)}
              className={`form-input pl-11 ${confirm.length > 0 && confirm !== password ? 'border-qfl-red/60' : ''}`}
            />
          </div>
          {confirm.length > 0 && confirm !== password && (
            <p className="text-qfl-red text-xs -mt-2 ml-1">Les mots de passe ne correspondent pas</p>
          )}

          <Button type="submit" variant="gold" size="lg" fullWidth loading={loading} disabled={!isValid} className="mt-1">
            METTRE À JOUR
          </Button>
        </form>
      </motion.div>
    </div>
  );
}

export default ResetPassword;

